<template >
  <div>
    <div>
      <div class="over container d-flex">
        <div
          class="container row align-items-center justify-content-center align-self-center"
        >
          <div
            style="position: absolute; top: 10px; left: 10px; z-index: 10"
            @click="openMain"
          >
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-arrow-left-short"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              style="color: white; font-size: 45px"
            >
              <path
                fill-rule="evenodd"
                d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
              />
            </svg>
          </div>

          <img src="../../../static/img/pessahFlyer.png" alt="" class="image" />
          <audio id="audio" controls autoplay class="audio">
            <source src="../../../static/sounds/Pessah1.mp3" type="audio/mp3" />
          </audio>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {};
  },
  mounted() {
    // setTimeout(() => {
    //   this.$router.push("/startGame");
    // }, 3000);
  },
  computed: {},

  methods: {
    openMain() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.audio {
  position: absolute;
  top: 12px;
  right: 12px;
  height: 40px;
}
.image {
  width: 100vw;
  position: absolute;
  top: 65px;
  left: 0;
  max-width: 590px;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
  border-radius: 36px;
  height: 56px;
  color: white;
}

.main {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  top: 52px;
  position: relative;
}

.myModal2 {
  width: 320px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  background-color: rgb(84, 163, 49);
  color: white;
  border: solid 2px white;
}
.over {
  position: fixed;
  top: 0px;
  font-size: 18px;
  width: 100vw;
  max-width: 590px;
  height: 100vh;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.9);
}

.center {
  display: block;
  margin: 0px auto;
}
</style>



